import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { markAsReadNotification } from "src/api/notify/notification";
import { clearNotificationIds } from "src/store/notifications/notificationsSlice";
import { MardAsReadPayload, RESPONSSTAUTS } from "src/types/api";
import { QUERYKEYS } from "src/types/queryKeys";
import { t } from "src/utils/i18nText";

export const useMarkAsReadNotification = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { mutateAsync, isPending, isError, data, isSuccess } = useMutation({
    mutationKey: [QUERYKEYS.MARK_READ_NOTIFICATION],
    mutationFn: (payload: MardAsReadPayload) => markAsReadNotification(payload),
    onSuccess: (data) => {
      if (data?.status === RESPONSSTAUTS.SUCCESS) {
        dispatch(clearNotificationIds());
        queryClient.invalidateQueries({
          queryKey: [QUERYKEYS.NOTIFICATIONS],
          refetchType: "active",
        });
      } else {
        const errorData = data?.response?.data;
        const errorMsg = t("queries.common.error");
        toast(errorData ? errorData?.notification_ids[0] : errorMsg);
      }
    },
    onError: () => {
      const errorMsg = t("queries.common.error");
      toast(errorMsg);
    },
  });

  return {
    isSuccess,
    data,
    isError,
    isPending,
    markReadMutate: mutateAsync,
  };
};
